export default function Footer() {

  return (
    <footer id="contact" className="relative bg-stone-800 text-white overflow-hidden">
      {/* Decorative World Map */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='100' height='100' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M10 10h80v80H10z' fill='none' stroke='white' stroke-width='0.5'/%3E%3C/svg%3E")`,
          backgroundSize: '100px 100px'
        }}></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 py-10 sm:py-16">
        {/* Main Content */}
        <div className="grid grid-cols-2 lg:grid-cols-7 gap-8 sm:gap-6 mb-10 sm:mb-12">
          {/* Left Section */}
          <div className="col-span-2 space-y-4 sm:space-y-6">
            <div className="flex items-center gap-3">
              <img 
                src="https://public.readdy.ai/ai/img_res/bb13b0f2-9633-4ffb-99f1-3e050d52c961.png" 
                alt="YMC Taipei Logo" 
                className="h-10 sm:h-12 w-10 sm:w-12 rounded-full object-cover"
              />
              <span className="text-lg sm:text-xl font-bold">YMC Taipei</span>
            </div>

            <div className="pt-2 sm:pt-4">
              <p className="text-xl sm:text-2xl font-serif leading-relaxed text-stone-300">
                研究 · 友誼 · 服務
              </p>
            </div>
          </div>

          {/* Navigation Links */}
          <div>
            <h4 className="font-bold mb-3 sm:mb-4 text-base sm:text-lg">關於我們</h4>
            <ul className="space-y-2 sm:space-y-3">
              <li><a href="#about" className="text-stone-400 hover:text-white transition-colors text-xs sm:text-sm">社團簡介</a></li>
              <li><a href="#about" className="text-stone-400 hover:text-white transition-colors text-xs sm:text-sm">核心宗旨</a></li>
              <li><a href="/contact" className="text-stone-400 hover:text-white transition-colors text-xs sm:text-sm">聯絡我們</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold mb-3 sm:mb-4 text-base sm:text-lg">活動資訊</h4>
            <ul className="space-y-2 sm:space-y-3">
              <li><a href="/annual-plan" className="text-stone-400 hover:text-white transition-colors text-xs sm:text-sm">年度計畫</a></li>
              <li><a href="#calendar" className="text-stone-400 hover:text-white transition-colors text-xs sm:text-sm">活動行事曆</a></li>
              <li><a href="/contact#apply" className="text-stone-400 hover:text-white transition-colors text-xs sm:text-sm">申請入社</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold mb-3 sm:mb-4 text-base sm:text-lg">會員專區</h4>
            <ul className="space-y-2 sm:space-y-3">
              <li><a href="/members" className="text-stone-400 hover:text-white transition-colors text-xs sm:text-sm">會員名冊</a></li>
              <li><a href="/leadership" className="text-stone-400 hover:text-white transition-colors text-xs sm:text-sm">組織架構</a></li>
            </ul>
          </div>

          {/* 全台青企聯盟 */}
          <div className="col-span-2 lg:col-span-1">
            <h4 className="font-bold mb-3 sm:mb-4 text-base sm:text-lg flex items-center gap-2">
              <i className="ri-links-line text-amber-400 w-4 h-4 flex items-center justify-center"></i>
              全台青企聯盟
            </h4>
            <ul className="space-y-2 sm:space-y-2.5">
              {[
                { name: '台北市青年企業研究社', url: 'https://www.facebook.com/YMCTaipei', icon: 'ri-facebook-fill', iconColor: 'text-[#1877F2]' },
                { name: '宜蘭青年企業研究社', url: 'https://www.facebook.com/share/1CcPVZKFVN/', icon: 'ri-facebook-fill', iconColor: 'text-[#1877F2]' },
                { name: '台中市青年企業研究社', url: 'https://www.facebook.com/groups/963423820450380', icon: 'ri-facebook-fill', iconColor: 'text-[#1877F2]' },
                { name: '台南市青年企業研究社', url: 'https://www.facebook.com/groups/136450169744175', icon: 'ri-facebook-fill', iconColor: 'text-[#1877F2]' },
                { name: '高雄市青年企業研究社', url: 'https://www.facebook.com/groups/224771110898345', icon: 'ri-facebook-fill', iconColor: 'text-[#1877F2]' },
                { name: '屏東縣青年企業研究社', url: 'https://www.facebook.com/groups/339546059466509', icon: 'ri-facebook-fill', iconColor: 'text-[#1877F2]' },
              ].map((item) => (
                <li key={item.url}>
                  <a
                    href={item.url}
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                    className="text-stone-400 hover:text-amber-300 transition-colors text-xs sm:text-sm flex items-center gap-1.5 group"
                  >
                    <i className={`${item.icon} ${item.iconColor} w-3.5 h-3.5 flex items-center justify-center flex-shrink-0`}></i>
                    <span className="group-hover:underline underline-offset-2">{item.name}</span>
                  </a>
                </li>
              ))}
              <li>
                <span className="text-stone-400 text-xs sm:text-sm flex items-center gap-1.5">
                  <i className="ri-building-line text-stone-500 w-3.5 h-3.5 flex items-center justify-center flex-shrink-0"></i>
                  <span>高雄首都青年企業研究社</span>
                </span>
              </li>
            </ul>
          </div>

          {/* 合作夥伴 */}
          <div className="col-span-2 lg:col-span-1">
            <h4 className="font-bold mb-3 sm:mb-4 text-base sm:text-lg flex items-center gap-2">
              <i className="ri-shake-hands-line text-amber-400 w-4 h-4 flex items-center justify-center"></i>
              合作夥伴
            </h4>
            <ul className="space-y-2 sm:space-y-2.5">
              {[
                { name: '基督教青年會(YMCA)', url: 'https://www.ymca.org.tw/', icon: 'ri-global-line', iconColor: 'text-stone-400' },
                { name: '國際工商經營研究社(IMC)', url: 'https://www.imc.org.tw/', icon: 'ri-global-line', iconColor: 'text-stone-400' },
                { name: '國際聯青社台灣總會', url: 'https://www.ysmen.org.tw/', icon: 'ri-global-line', iconColor: 'text-stone-400' },
                { name: '青影社', url: 'https://www.facebook.com/share/g/18PQtXfFzF/', icon: 'ri-facebook-fill', iconColor: 'text-[#1877F2]' },
                { name: '聖樂團', url: 'https://www.facebook.com/share/18DSQzrciq/', icon: 'ri-facebook-fill', iconColor: 'text-[#1877F2]' },
                { name: '青企台語國際演講會', url: 'https://www.facebook.com/groups/Ymictoastmasters', icon: 'ri-facebook-fill', iconColor: 'text-[#1877F2]' },
              ].map((item) => (
                <li key={item.url}>
                  <a
                    href={item.url}
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                    className="text-stone-400 hover:text-amber-300 transition-colors text-xs sm:text-sm flex items-center gap-1.5 group"
                  >
                    <i className={`${item.icon} ${item.iconColor} w-3.5 h-3.5 flex items-center justify-center flex-shrink-0`}></i>
                    <span className="group-hover:underline underline-offset-2">{item.name}</span>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="pt-6 sm:pt-8 border-t border-stone-700">
          <div className="flex flex-col gap-4 sm:gap-6 items-center">
            <p className="text-xs sm:text-sm text-stone-400 text-center order-2 sm:order-1">
              © 2026 YMC Taipei. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
